export const BETALNINGSUPPGIFT_REMINDER_PENDING_KEY =
  'betalningsuppgiftReminderPending';
export const BEDOMARE_REMINDER_PENDING_KEY = 'bedomareReminderPending';
